import { useQuery } from '@tanstack/react-query'
import { accountInfoApi } from '@/shared/api/accountInfoApi'

const REFETCH_INTERVAL = 60 * 1000

interface UseProfileQueryParams {
  token: string | null
  currentServer: string
}

export const useProfileQuery = ({
  token,
  currentServer,
}: UseProfileQueryParams) =>
  useQuery({
    queryKey: ['profile', currentServer, token],
    enabled: !!token,
    queryFn: () => accountInfoApi.getProfile(currentServer, token!),
    refetchInterval: REFETCH_INTERVAL,
  })
